export default __webpack_public_path__ + "static/media/seo.c65ed5d8.svg";